import { t } from '@/utils/i18n'
import React from 'react'
import { useCorpSettingStore, useCorpInfoStore } from '@/stores'
import { utils } from '@/utils'
import styles from './ProductCellPrice.module.less'
interface ProductCellPriceProps {
  index: number
  useCustomStyle?: boolean
  lineHeightType?: number
  value: number | string
  isDelete?: boolean
  linePrice?: number | string
  unit?: string
  isLastPrice?: boolean
  isMultiUnit?: boolean // 是否多单位
  fontSize?: string
  onTriggerUnitSelect?: (index: number) => void
}

const { px2rem } = utils
const ProductCellPrice: React.FC<ProductCellPriceProps> = ({
  index,
  useCustomStyle = false,
  lineHeightType = 0,
  value = '',
  isDelete = false,
  linePrice = 0,
  unit = t('个'),
  isLastPrice = false,
  isMultiUnit = false,
  fontSize = px2rem(36),
  onTriggerUnitSelect,
}) => {
  const { corpSetting,  } = useCorpSettingStore()
  const { corpInfo } = useCorpInfoStore()
  const { accountId } = corpInfo
  const { currencySymbol } = corpSetting
  let containerClassName = styles['kp-price-container']

  if (lineHeightType === 1) {
    containerClassName += styles['line-height-1']
  }

  if (isDelete) {
    containerClassName += styles['delete']
  }

  const priceStyle = {
    fontSize,
  }

  const handleTriggerUnitSelect = () => {
    onTriggerUnitSelect && onTriggerUnitSelect(index)
  }

  return (
    <div className={containerClassName}>
      {/* 没有自定义样式，多单位时 */}
      {(!useCustomStyle && isMultiUnit) && (
        <div
          className={styles['kp-price-content']}
          onClick={handleTriggerUnitSelect}
        >
          {/* 现价 */}
          <div className={styles['current-price']}>
            {/* 价格符号 */}
            <p>{currencySymbol}</p>
            {/* 价格 */}
            <p className={styles['kp-price']} style={priceStyle}>
              { accountId ? value : '***'}
            </p>
            {/* 单位 */}
            <p>{unit ? '/' + unit : ''}</p>
            {/* 下拉箭头 */}
            <div className={styles['price-unit'] + 'triangle-down'}></div>
          </div>
          {/* 上次价 */}
          {isLastPrice && (
            <div className={styles['last-price']}>
              <p>{t('上次价')}</p>
            </div>
          )}

          {/* 划线价：可能是一个范围值 1-10 */}
          {(String(linePrice) !== '0' && linePrice.toString().length > 0) && (
            <div className={styles['line-through']}>
              <p>
                {currencySymbol}
                {accountId ? linePrice : '***'}
                {unit ? '/' + unit : ''}
              </p>
            </div>
          )}
        </div>
      )}

      {/* 没有自定义样式，一个单位时 */}
      {(!useCustomStyle && !isMultiUnit) && (
        <div className={styles['kp-price-content']}>
          <div className={styles['current-price']}>
            <p>{currencySymbol}</p>
            <p className={styles['kp-price']} style={priceStyle}>
              {accountId ? value : '***'}
            </p>
            <p>{unit ? '/' + unit : ''}</p>
          </div>

          {/* 上次价 */}
          {isLastPrice && (
            <div className={styles['last-price']}>
              <p>{t('上次价')}</p>
            </div>
          )}

          {/* 划线价 */}
          {(String(linePrice) !== '0' && linePrice.toString().length > 0) && (
            <div className={styles['line-through']}>
              <p>
                {currencySymbol}
                {accountId ? linePrice : '***'}
                {unit ? '/' + unit : ''}
              </p>
            </div>
          )}
        </div>
      )}

      {/* 有自定义样式 */}
      {useCustomStyle && (
        <div className={styles['kp-price-content']}>
          <div className={styles['current-price']}>
            <p>{currencySymbol}</p>
            <p className={styles['kp-price']} style={priceStyle}>
              {accountId ? value : '***'}
            </p>
            <p>{unit ? '/' + unit : ''}</p>
          </div>

          {/* 划线价 */}
          {(String(linePrice) !== '0' && linePrice.toString().length > 0) && (
            <div className={styles['line-through']}>
              <p>
                {currencySymbol}
                {accountId ? linePrice : '***'}
                {unit ? '/' + unit : ''}
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default ProductCellPrice
